import {
  ADDRESS_WITHOUT_COMPLEMENT,
  DAMAGED_PACKAGE,
  DELAYED_DELIVERY,
  DELAYED_DELIVERY_WITH_NEW_DATE,
  LOST_PACKAGE,
  STOLEN_PACKAGE,
  UNAVAILABLE_CANCELED,
  UNAVAILABLE_RECIPIENT,
  UNAVAILABLE_RECIPIENT_WITH_NEW_DATE,
  WAITING_DEVOLUTION,
  WRONG_ADDRESS
} from 'shared/status/status.constants';

const STATUS_TO_RENDER_FORECAST_INFO = [
  ADDRESS_WITHOUT_COMPLEMENT,
  DELAYED_DELIVERY,
  DELAYED_DELIVERY_WITH_NEW_DATE,
  UNAVAILABLE_RECIPIENT,
  UNAVAILABLE_RECIPIENT_WITH_NEW_DATE,
  WRONG_ADDRESS
];

const STATUS_TO_NOT_RENDER_FORECAST_DATE = [
  DAMAGED_PACKAGE,
  LOST_PACKAGE,
  STOLEN_PACKAGE,
  UNAVAILABLE_CANCELED,
  WAITING_DEVOLUTION
];

export { STATUS_TO_RENDER_FORECAST_INFO, STATUS_TO_NOT_RENDER_FORECAST_DATE };
